import React, { Component } from "react";

import { withRouter } from "react-router-dom";

import { AppContext } from "../../App";
import Loader from "../../components-utils/Loader";
import I18n from "../../components-utils/I18n";
import PhotoHeader from "../../components-utils/PhotoHeader";
import { validateObject, mandatory } from "../../services/validator";

import {
  getCategory,
  saveCategory,
  uploadCategoryPhoto,
  deleteCategoryPhoto
} from "../../services/api";
import { loadItem } from "../../services/utils";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import "./Category.css";

const emptyI18n = {
  label: "",
  description: ""
};
const emptyCategory = (merchantCode, langs) => ({
  productCategory: {
    id: -1,
    merchantCode: merchantCode,
    rank: 0,
    products: []
  },
  productCategoryI18n: langs.reduce(
    (acc, lang) => ({ ...acc, [lang.code]: emptyI18n }),
    {}
  )
});

class Category extends Component {
  state = {
    lang: "fr",
    randomSuffix: Math.random(),
    errors: {}
  };

  async componentDidMount() {
    const result = await loadItem(this.props, getCategory, emptyCategory);
    if (result !== undefined) {
      this.setState({
        category: result.item,
        merchantCode: result.merchantCode
      });
    }
  }

  changeLang = lang => {
    this.setState({ lang });
  };
  changeFields = name => e => {
    const value = e.target.value;
    const { productCategory } = this.state.category;
    this.setState(state => ({
      category: {
        productCategory:
          state.lang === "fr" && name === "label"
            ? {
                ...productCategory,
                value: { ...productCategory.value, technicalLabel: value }
              }
            : productCategory,
        productCategoryI18n: {
          ...state.category.productCategoryI18n,
          [state.lang]: {
            ...state.category.productCategoryI18n[state.lang],
            [name]: value
          }
        }
      }
    }));
  };

  labelValidators = this.props.langs.reduce(
    (acc, lang) => ({ ...acc, [lang.code]: { label: [mandatory] } }),
    {}
  );

  saveCategory = () => {
    const {
      category: { productCategoryI18n }
    } = this.state;

    const errors = validateObject(productCategoryI18n, this.labelValidators);

    this.setState({ errors }, () => {
      const { errors, category, merchantCode } = this.state;
      if (errors === undefined) {
        const {
          snackbar,
          history,
          match: {
            params: { id }
          }
        } = this.props;
        if (merchantCode !== undefined) {
          saveCategory(id, merchantCode, category)
            .then(category => {
              this.setState({ category }, () => {
                history.push(`/categories/${category.productCategory.id}`);
                snackbar("Informations enregistrées");
              });
            })
            .catch(e => {
              console.log(e);
              snackbar(
                "Erreur pendant la sauvegarde de la catégorie. Veuillez réessayer",
                "error"
              );
            });
        }
      }
    });
  };

  uploadPhoto = async file => {
    const { snackbar } = this.props;
    const {
      merchantCode,
      category: {
        productCategory: { id }
      }
    } = this.state;

    try {
      const category = await uploadCategoryPhoto(id, merchantCode, file);
      this.setState(
        state => ({ category, randomSuffix: Math.random() }),
        () => snackbar("Photo enregistrée")
      );
    } catch (e) {
      snackbar(
        "Une erreur est survenue pendant l'enregistrement de la photo, veuillez réessayer",
        "error"
      );
    }
  };

  deletePhoto = async () => {
    const { snackbar } = this.props;
    const {
      merchantCode,
      category: {
        productCategory: { id }
      }
    } = this.state;
    try {
      const category = await deleteCategoryPhoto(id, merchantCode);
      this.setState({ category }, () => snackbar("Photo supprimée"));
    } catch (e) {
      snackbar(
        "Une erreur est survenue pendant la suppression, veuillez réessayer",
        "error"
      );
    }
  };

  renderLoader() {
    return <Loader loading={true} />;
  }

  render() {
    const { category, lang, merchantCode, errors, randomSuffix } = this.state;

    return category !== undefined ? (
      <Card key="page">
        <PhotoHeader
          disabled={category !== undefined && category.productCategory.id <= 0}
          photo={
            category !== undefined &&
            category.productCategory.value !== undefined
              ? category.productCategory.value.photo
              : undefined
          }
          path={`public/${merchantCode}/categories`}
          uploadPhoto={this.uploadPhoto}
          deletePhoto={this.deletePhoto}
          snackbar={this.props.snackbar}
          randomSuffix={randomSuffix}
        />
        <CardContent>
          <Typography variant="h4">
            {category &&
            category.productCategory &&
            category.productCategory.value
              ? category.productCategory.value.technicalLabel
              : "Nouvelle Catégorie"}
          </Typography>
          <I18n
            langs={this.props.langs}
            lang={lang}
            changeFields={this.changeFields}
            changeLang={this.changeLang}
            elements={category.productCategoryI18n}
            emptyElement={emptyI18n}
            errors={errors}
          />
        </CardContent>

        <CardActions className="sp-category--actions">
          <Button
            variant="contained"
            color="secondary"
            onClick={this.saveCategory}
          >
            Valider
          </Button>
        </CardActions>
      </Card>
    ) : (
      this.renderLoader()
    );
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => {
        return (
          <WrappedComponent
            {...props}
            snackbar={app.snackbar.open}
            langs={app.langs}
          />
        );
      }}
    </AppContext.Consumer>
  );
};

export default withRouter(enhanced(Category));



// WEBPACK FOOTER //
// ./src/components/categories/Category.js